import React from 'react';

const UnderMaintenance = () => {
  const handleDoubleClick = () => {
    window.location.href = 'http://192.168.0.218:5173/';
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: '480px' }}>
        <h1
          onDoubleClick={handleDoubleClick}
          style={{ marginBottom: '12px', cursor: 'pointer' }}
        >
          Under Maintenance
        </h1>
        <p style={{ margin: 0, lineHeight: 1.5 }}>
          The home page is temporarily under maintenance until 4:00 AM (CT).
          We apologize for the inconvenience.
        </p>
      </div>
    </div>
  );
};

export default UnderMaintenance;
